import OnlyHeader from "components/Headers/OnlyHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { acceptRequest } from "store/actions/changeAdminaction";
import { rejectRequest } from "store/actions/changeAdminaction";
import { getChangeAdminRequests } from "store/actions/changeAdminaction";

const ChangeAdminRequests = () => {
  let dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [action, setAction] = useState({
    type: "",
    id: "",
  });
  const [btnLoader, setBtnLoader] = useState(false);
  const { uid } = useSelector((state) => state.auth);
  const { requests } = useSelector((state) => state.changeAdmin);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getChangeAdminRequests(uid, () => {
        setIsLoading(false);
      })
    );
  }, []);

  const toggle = () => {
    setModal(!modal);
  };

  const handleAction = () => {
    setBtnLoader(true);
    if (action.type == "Reject") {
      dispatch(
        rejectRequest(action.id, () => {
          toggle();
          setBtnLoader(false);
          toast.success("Reject request successfully");
        })
      );
    } else {
      dispatch(
        acceptRequest(action.id, () => {
          toggle();
          setBtnLoader(false);
          toast.success("Accept request successfully");
        })
      );
    }
  };
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              {isLoading ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <Table
                    className="align-items-center table-flush mb-3"
                    responsive
                  >
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">State</th>
                        <th scope="col">City</th>
                        <th scope="col">School</th>
                        <th scope="col">Status</th>
                        <th scope="col" className="text-center">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {requests && requests.length > 0 ? (
                        requests.map((item, index) => (
                          <tr key={index}>
                            <td>{item.name}</td>
                            <td>{item.email}</td>
                            <td>{item.state}</td>
                            <td>{item.county}</td>
                            <td>{item.instituteName}</td>
                            <td>{item.status}</td>
                            <td className="text-center">
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  setAction({
                                    type: "Reject",
                                    id: item.id,
                                  });
                                  toggle();
                                }}
                              >
                                Reject
                              </Button>
                              <Button
                                color="primary"
                                size="sm"
                                onClick={() => {
                                  setAction({
                                    type: "Accept",
                                    id: item.id,
                                  });
                                  toggle();
                                }}
                              >
                                Accept
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={modal} centered toggle={toggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to {action.type}.
            </span>
            <br />
            <br />
            <br />
            <Button color="danger" onClick={toggle}>
              No
            </Button>{" "}
            <Button color="primary" onClick={handleAction}>
              {btnLoader ? <Spinner size="sm" /> : "Yes"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ChangeAdminRequests;
